import { createRouter, createWebHistory } from "vue-router";


//import axios from 'axios';
import store from "../store";

import dashboard from "@/views/taskSprint/dashboard/dashboard-user.vue";
import newDashboardPM from "@/views/taskSprint/dashboard/new-dashboard-pm.vue";
import genericError from "@/views/errors/generic.vue";
import { log } from "@/script/log";
import axios from "axios";
//Errors
// import genericError from "@/views/errors/generic.vue";

const routes = [
    {
        path: "/dashboard/",
        name: "dashboard",
        component: dashboard,
        props: true // Permette di passare user_id come pr
    },
    {
        path: "/dashboard-pm/",
        name: "dashboardPM",
        component: newDashboardPM,
        props: true // Permette di passare user_id come pr
    },
    {
        path: "/:ACCESS_TOKEN/dashboard",
        redirect: (to) => {
            sessionStorage.setItem('ACCESS_TOKEN', to.params.ACCESS_TOKEN)
            sessionStorage.setItem('isIframe', true);
            sessionStorage.setItem('isPM', false)
            return `/dashboard/`;
        }
    },
    {
        path: "/:ACCESS_TOKEN/dashboard-pm",
        redirect: (to) => {
            sessionStorage.setItem('ACCESS_TOKEN', to.params.ACCESS_TOKEN)
            sessionStorage.setItem('isPM', true)
            return `/dashboard-pm/`;
        }
    },
    {
        path: "/:ACCESS_TOKEN/dashboard-pm/:idTicket",
        redirect: (to) => {
            sessionStorage.setItem('ACCESS_TOKEN', to.params.ACCESS_TOKEN)
            sessionStorage.setItem('isPM', true)
            store.dispatch('applicaFiltriRequest', { idTicket:to.params.idTicket });


            return `/dashboard-pm/`;
        }
    },
    {
        path: "/error",
        name: "error",
        component: genericError,
        props: route => ({ errorMessage: route.params.errorMessage })
    },
    {
        path: "/",
        redirect: () => ({
            name: "error",
            query: {
                errorMessage: `Pagina non valida, forse cercavi "${window.location.origin}/dashboard"?`
            }
        })
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
    log("Global redirect log", `Navigating from '${from.fullPath}' to '${to.fullPath}'`);
    next();
});

export default router;
